module.exports = __webpack_public_path__ + "img/title-bar.5256eca4.jpg";